import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    appointments: [],
    services: [],
    drivers: [],
    trucks: [],
    dates: [],
    isLoadingFetch: false,
    appointmentsSelected: [],
    form: {
        idTruck: null,
        idDriver: null,
        observations: "",
    }
};

const assignmentSlice = createSlice({
    name: "assignment",
    initialState,
    reducers: {
        setAppointments(state, action) {
            return { 
                ...state,
                appointments: action.payload.appointments,
            };
        },
        setIsLoadingFetch(state, action) {
            return { ...state, isLoadingFetch: action.payload };
        },
        setAppointmentsSelected(state, action) {
            return { 
                ...state,
                appointmentsSelected: action.payload,
            };
        },
        setServices(state, action) {
            return { ...state, services: action.payload };
        },
        setDrivers(state, action) {
            return { ...state, drivers: action.payload };
        },
        setTrucks(state, action) {
            return { ...state, trucks: action.payload };
        },
        setForm(state, action) {
            return { ...state, form: action.payload };
        },
        setDates(state, action) {
            return { 
                ...state,
                dates: action.payload,
            }
        },
        resetState() {
            return initialState;
        },
        resetStateByFilter(state) {
            return {
                ...state,
                appointments: [],
                appointmentsSelected: [],
            }
        },
        resetForm(state) {
            return {
                ...state,
                form: {
                    idTruck: null,
                    idDriver: null,
                    observations: "",
                }
            }
        }
    },
});

export const {
    setAppointments,
    setAppointmentsSelected,
    setIsLoadingFetch,
    setServices,
    setDrivers,
    setTrucks,
    setForm,
    setDates,
    resetState,
    resetStateByFilter,
    resetForm,
} = assignmentSlice.actions;

export default assignmentSlice.reducer;